import type { AppEnvSchema } from './env-schema';

/** Every environment variable Terra code may read: the keys of `AppEnvSchema`. */
export type EnvKey = keyof typeof AppEnvSchema.shape;

/**
 * Reads one declared variable from the live process env, at call time. Returns
 * the raw string, so an unset var is `undefined` and a blank one is `''`; the
 * caller keeps its own coercion and defaulting. `rawEnv` (src/config/env.ts) is
 * a load-time snapshot and cannot serve a read that tests or boot code change
 * after import.
 */
export function readEnv(key: EnvKey): string | undefined {
  return process.env[key];
}

/** A fresh copy of the live process env, for a child process env or a whole-env schema parse. */
export function envSnapshot(): NodeJS.ProcessEnv {
  return { ...process.env };
}
